import PlatformPassword from './PlatformPassword';

export default PlatformPassword;
